<span class="chip chip-success" *ngIf="state == discountState.ACTIVE">
  {{'state.active' | translate}}
</span>
<span class="chip chip-info" *ngIf="state == discountState.DRAFT">
  {{'state.draft' | translate}}
</span>
<span class="chip chip-warning" *ngIf="state == discountState.DELETED">
  {{'state.deleted' | translate}}
</span>